// TODO seperate stripe logic from route logic
import * as React from "react";
import csx from "classnames";
import { Route, Switch } from "react-router-dom";
import { withTheme } from "styled-components";

import { withTemplate } from "components/hocs";
import { Condition } from "components/elements";
import { useResource, useScript } from "hooks";
import { Loader, Confirm } from "components/fragments";
import { Copy, Routes } from "utils";
import { RouteWithProps } from "components/fragments/Routes";
import { PATRON_DELETE_CARD } from "utils/api";
import CheckoutForm from "./checkoutForm";
import DrawerButton from "../../../DrawerButton";
import { CARD_ROUTES } from "../../../../pages/Profile/Cards/utils";
import { CheckoutCardList } from "./CheckoutCardList";

import css from "./stripe.module.scss";

const { Condition: If } = Condition;

function Stripe(props) {
  const {
    style: { cells },
    onSuccess,
    history,
  } = props;

  const [{ resource: locationCreds, fetching }] = useResource({
    data: {},
    method: "get",
    path: "/location/credentials",
  });

  const [{ resource = [] }] = useResource({
    path: Routes.FETCH_CARDS,
  });

  const { loaded, error } = useScript("https://js.stripe.com/v3/");

  if (!loaded) {
    return null;
  }

  if (error) {
    console.error("Unable to load Payment Form");
    return <></>;
  }

  const toAddCard = () => history.push(CARD_ROUTES.ADD_CARD);

  const deleteCard = async (id) => {
    try {
      await PATRON_DELETE_CARD(id);
      history.goBack();
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <Route>
      <Switch>
        <RouteWithProps
          path={CARD_ROUTES.ADD_CARD}
          render={() => (
            <>
              <If is={fetching}>
                <Loader />
              </If>
              <If is={locationCreds.publicKey}>
                <CheckoutForm {...props} apiKey={locationCreds.publicKey} />
              </If>
            </>
          )}
          order={{}}
          onSuccess={history.goBack}
        />
        <RouteWithProps
          path={CARD_ROUTES.DELETE_CARD}
          render={({ match }) => (
            <Confirm
              isNegativeConfirm
              message={Copy.PROFILE_STATIC.DELETE_CARD_CONFIRM_MESSAGE}
              confirmText={Copy.PROFILE_STATIC.CONFIRM_BUTTON_TEXT}
              cancelText={Copy.PROFILE_STATIC.CANCEL_BUTTON_TEXT}
              onConfirm={() => deleteCard(match.params.cardId)}
              onCancel={history.goBack}
            />
          )}
        />
        <RouteWithProps
          path={Routes.FETCH_CARDS}
          render={() => {
            if (resource.length) {
              return (
                <div className={css.stripeForm}>
                  <div
                    className={csx(css["stripeForm-container"], "payment-form")}
                  >
                    <CheckoutCardList
                      resource={resource}
                      cells={cells}
                      onSuccess={onSuccess}
                      history={history}
                    />
                  </div>
                  <DrawerButton
                    buttonProps={{ id: "my-submit", onClick: toAddCard }}
                  >
                    {Copy.PAYMENT_FORM_STATIC.ADD_NEW_CARD}
                  </DrawerButton>
                </div>
              );
            }
            return (
              <>
                <If is={fetching}>
                  <Loader />
                </If>
                <If is={locationCreds.publicKey}>
                  <CheckoutForm {...props} apiKey={locationCreds.publicKey} />
                </If>
              </>
            );
          }}
        />
      </Switch>
    </Route>
  );
}

export default withTheme(withTemplate(Stripe, "payment"));
